import * as MbUserAddressesAction from './mb-user-addresses.action'

export {  MbUserAddressesAction }
